import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { restoreSessionAsync } from "./app/userSlice";
import { Mask, Loader } from "./components";
import { selectIsLoading } from "./app/uiSlice";
import { BrowserRouter } from "react-router-dom";
import RenderRoutes from "./renderRoutes";
import ScrollToTop from "./hooks/ScrollToTop";
import { SimplePersistence } from "./utils";
import { SIGNIN_TOKEN } from "./constants";

const storage = new SimplePersistence();

export const App = ({ RouterComponent = BrowserRouter }) => {
  const dispatch = useDispatch();
  const loading = useSelector(selectIsLoading);
  const [sessionChecked, setSessionChecked] = useState(!storage.getItem(SIGNIN_TOKEN));

  useEffect(() => {
    if (!sessionChecked) {
      dispatch(restoreSessionAsync()).finally(() => setSessionChecked(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!sessionChecked) {
    return <Loader />;
  }

  return (
    <RouterComponent
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <ScrollToTop />
      <div className="App" data-testid="app" style={{ backgroundColor: "#dadee0" }}>
        <RenderRoutes />
        {loading && <Mask />}
      </div>
    </RouterComponent>
  );
};
